"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
export default function UserSettingsBackground(t0) {
  const $ = _c(23);
  const {
    bgColor1,
    bgColor2,
    setBgColor1,
    setBgColor2
  } = t0;
  const bgColor1Ref = useRef(null);
  const bgColor2Ref = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (bgColor1Ref.current) {
        bgColor1Ref.current.click();
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onBgColor1Click = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (bgColor2Ref.current) {
        bgColor2Ref.current.click();
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const onBgColor2Click = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <label className="tw-block tw-text-sm tw-font-semibold tw-leading-5 tw-text-iron-300">Background Color 1</label>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== setBgColor1) {
    t4 = e => setBgColor1(e.target.value);
    $[3] = setBgColor1;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== bgColor1 || $[6] !== t4) {
    t5 = <input ref={bgColor1Ref} type="color" id="bgColor1" name="bgColor1" value={bgColor1} onChange={t4} className="tw-cursor-pointer tw-block tw-w-full tw-rounded-lg tw-border-0 tw-py-3 tw-h-12 tw-px-3 tw-pr-10 tw-bg-iron-900 tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 hover:tw-ring-iron-600 tw-text-base sm:tw-leading-6 tw-transition tw-duration-300 tw-ease-out" />;
    $[5] = bgColor1;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div onClick={onBgColor1Click} className="tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-3"><svg className="tw-h-4 tw-w-4 tw-text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 10L14 6M2.49997 21.5L5.88434 21.124C6.29783 21.078 6.50457 21.055 6.69782 20.9925C6.86926 20.937 7.03242 20.8586 7.18286 20.7594C7.35242 20.6475 7.49951 20.5005 7.7937 20.2063L21 7C22.1046 5.89543 22.1046 4.10457 21 3C19.8954 1.89543 18.1046 1.89543 17 3L3.7937 16.2063C3.49952 16.5005 3.35242 16.6475 3.24061 16.8171C3.1414 16.9676 3.06298 17.1307 3.00748 17.3022C2.94493 17.4954 2.92195 17.7021 2.87601 18.1156L2.49997 21.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></div>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5) {
    t7 = <div className="tw-w-full md:tw-flex-1 tw-cursor-pointer">{t3}<div className="tw-mt-2 tw-relative">{t5}{t6}</div></div>;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <label className="tw-block tw-text-sm tw-font-semibold tw-leading-5 tw-text-iron-300">Background Color 2</label>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== setBgColor2) {
    t9 = e_0 => setBgColor2(e_0.target.value);
    $[12] = setBgColor2;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== bgColor2 || $[15] !== t9) {
    t10 = <input ref={bgColor2Ref} type="color" id="bgColor2" name="bgColor2" value={bgColor2} onChange={t9} className="tw-cursor-pointer tw-block tw-w-full tw-rounded-lg tw-border-0 tw-py-3 tw-h-12 tw-px-3 tw-pr-10 tw-bg-iron-900 tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 hover:tw-ring-iron-600 tw-text-base sm:tw-leading-6 tw-transition tw-duration-300 tw-ease-out" />;
    $[14] = bgColor2;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div onClick={onBgColor2Click} className="tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-3"><svg className="tw-h-4 tw-w-4 tw-text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 10L14 6M2.49997 21.5L5.88434 21.124C6.29783 21.078 6.50457 21.055 6.69782 20.9925C6.86926 20.937 7.03242 20.8586 7.18286 20.7594C7.35242 20.6475 7.49951 20.5005 7.7937 20.2063L21 7C22.1046 5.89543 22.1046 4.10457 21 3C19.8954 1.89543 18.1046 1.89543 17 3L3.7937 16.2063C3.49952 16.5005 3.35242 16.6475 3.24061 16.8171C3.1414 16.9676 3.06298 17.1307 3.00748 17.3022C2.94493 17.4954 2.92195 17.7021 2.87601 18.1156L2.49997 21.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></div>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10) {
    t12 = <div className="tw-w-full md:tw-flex-1 tw-cursor-pointer">{t8}<div className="tw-mt-2 tw-relative">{t10}{t11}</div></div>;
    $[18] = t10;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t7) {
    t13 = <div className="tw-flex tw-flex-wrap md:tw-flex-nowrap tw-gap-y-6 tw-gap-x-5">{t7}{t12}</div>;
    $[20] = t12;
    $[21] = t7;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}